import React, {useEffect} from 'react';
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  withRepeat,
  withTiming,
  Easing,
  FadeIn,
  FadeOut,
} from 'react-native-reanimated';
import styled from 'styled-components/native';
import {Platform, ViewStyle} from 'react-native';
import Icon from '../icon';

// Import circle image statically for web
const circleImage = require('../../assets/images/circle.png');

const Container = styled(Animated.View)`
  align-items: center;
  justify-content: center;
  width: 100%;
  ${Platform.OS === 'web' ? 'display: flex;' : ''}
`;

const ContentContainer = styled.View`
  width: 100%;
  aspect-ratio: 1;
  align-items: center;
  justify-content: center;
  ${Platform.OS === 'web' ? 'display: flex;' : ''}
`;

const ImageContainer = styled.View`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  align-items: center;
  justify-content: center;
  ${Platform.OS === 'web' ? 'display: flex;' : ''}
`;

const ImageContentContainer = styled(Animated.View)`
  width: 75%;
  height: 75%;
  aspect-ratio: 1;
  ${Platform.OS === 'web' ? 'display: flex;' : ''}
`;

const IconContentContainer = styled(Animated.View)`
  width: 100%;
  height: 100%;
  aspect-ratio: 1;
  ${Platform.OS === 'web' ? 'display: flex;' : ''}
`;

const WaveContainer = styled(Animated.View)`
  width: 100%;
  height: 100%;
  aspect-ratio: 1;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  align-items: center;
  justify-content: center;
  ${Platform.OS === 'web' ? 'display: flex;' : ''}
`;

const Image = styled.Image`
  width: 100%;
  height: 100%;
  aspect-ratio: 1;
  z-index: 2;
  ${Platform.OS === 'web' ? 'object-fit: contain;' : ''}
`;

const CircleRecordingView = ({
  isRecording,
  style,
}: {
  isRecording: boolean;
  style?: ViewStyle;
}) => {
  const rotation = useSharedValue(0);

  useEffect(() => {
    // Start animation immediately
    rotation.value = withRepeat(
      withTiming(360, {
        duration: isRecording ? 10000 : 40000,
        easing: Easing.linear,
      }),
      -1,
      false,
    );
  }, [isRecording]);

  const animatedStyle = useAnimatedStyle(() => ({
    transform: [{rotate: `${rotation.value}deg`}],
  }));

  const animatedReverseStyle = useAnimatedStyle(() => ({
    transform: [{rotate: `-${rotation.value}deg`}],
  }));

  return (
    <Container entering={FadeIn} exiting={FadeOut} style={style}>
      <ContentContainer>
        {isRecording && (
          <WaveContainer entering={FadeIn} exiting={FadeOut}>
            <Icon name={'wave'} size={'50%'} color={'#fff'} />
          </WaveContainer>
        )}
        <ImageContainer>
          <ImageContentContainer style={animatedStyle}>
            <Image
              resizeMode={'contain'}
              source={require('../../assets/images/circle.png')}
            />
          </ImageContentContainer>
        </ImageContainer>
        {Platform.OS !== 'web' && (
          <IconContentContainer style={isRecording ? animatedReverseStyle : {}}>
            <Icon name={'recordBackground'} size={'100%'} color={'#fff'} />
          </IconContentContainer>
        )}
      </ContentContainer>
    </Container>
  );
};

export default CircleRecordingView;
